<template>
  <div>
    <transition
      enter-active-class="ease-out duration-300"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="ease-in duration-200"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="isOpen"
        class="fixed z-50 inset-0 overflow-y-auto"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div
          class="
            flex
            items-end
            justify-center
            min-h-screen
            pt-4
            px-4
            pb-20
            text-center
            sm:block sm:p-0
          "
        >
          <div
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            aria-hidden="true"
          ></div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >
          <div
            class="
              inline-flex
              flex-col
              align-bottom
              bg-white
              rounded-lg
              text-left
              overflow-hidden
              shadow-xl
              transform
              transition-all
              relative
              sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full
            "
            style="height: 560px"
          >
            <!-- loading overlay -->
            <div
              v-if="loadingSubmit"
              class="
                absolute
                inset-0
                z-10
                flex flex-col
                items-center
                justify-center
                bg-white bg-opacity-80
                rounded-lg
              "
            >
              <svg
                class="animate-spin h-10 w-10 text-cyan-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                />
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              <p class="mt-3 text-sm text-gray-600">กำลังคัดลอกการตั้งค่า...</p>
            </div>
            <!-- end loading overlay -->
            <div class="bg-white p-4 sm:p-6 flex-1 min-h-0 flex flex-col">
              <div class="flex flex-col flex-1 min-h-0">
                <div class="flex flex-col flex-1 w-full min-h-0">
                  <div class="flex items-start justify-between">
                    <h3
                      class="text-2xl leading-6 font-medium text-gray-900"
                      id="modal-title"
                    >
                      <slot name="title">คัดลอกการตั้งค่า Device</slot>
                    </h3>
                    <button
                      @click="onCancel"
                      type="button"
                      class="
                        ml-4
                        text-gray-400
                        hover:text-gray-600
                        focus:outline-none
                      "
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-5 h-5"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M6 18 18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                  <div class="mt-2">
                    <AppAutoComplete
                      v-model="filterCompany"
                      :isLoading="loadingCompany"
                      :isSearch="true"
                      :options="companies"
                      label="เลือกข้อมูล Device ตามบริษัท"
                      item-text-key="text"
                      item-value-key="company_uuid"
                      class="w-full flex-shrink-0"
                      @input="handleFilterCompany"
                    />
                  </div>
                  <div class="mt-4 flex flex-row gap-4 w-full flex-1 min-h-0">
                    <div class="flex flex-col flex-1 min-h-0 gap-1">
                      <span class="text-sm font-medium text-gray-600"
                        >Device ต้นทาง</span
                      >
                      <div class="relative">
                        <input
                          v-model="searchSource"
                          type="text"
                          placeholder="ค้นหา..."
                          class="
                            w-full
                            border border-gray-300
                            rounded-lg
                            pl-9
                            pr-8
                            py-2
                            text-sm
                            focus:ring-1
                            focus:ring-cyan-500
                            focus:border-cyan-500
                          "
                          @input="onSearchSource"
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="
                            w-4
                            h-4
                            text-gray-400
                            absolute
                            left-2.5
                            top-1/2
                            transform
                            -translate-y-1/2
                            pointer-events-none
                          "
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.197 5.197a7.5 7.5 0 0 0 10.606 10.606Z"
                          />
                        </svg>
                        <button
                          v-if="searchSource"
                          @click="clearSearchSource"
                          type="button"
                          class="
                            absolute
                            right-2
                            top-1/2
                            transform
                            -translate-y-1/2
                            text-gray-400
                            hover:text-gray-600
                          "
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-4 h-4"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M6 18 18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                      <div
                        ref="sourceListEl"
                        class="
                          border border-gray-300
                          rounded-lg
                          w-full
                          flex-1
                          overflow-y-auto
                        "
                        @scroll="onScrollSource"
                      >
                        <div
                          v-if="!filterCompany"
                          class="
                            flex
                            items-center
                            justify-center
                            h-full
                            text-sm text-gray-400
                            p-4
                          "
                        >
                          กรุณาเลือกบริษัทก่อน
                        </div>
                        <div
                          v-else-if="
                            !loadingHardware && sourceList.length === 0
                          "
                          class="
                            flex
                            items-center
                            justify-center
                            h-full
                            text-sm text-gray-400
                            p-4
                          "
                        >
                          ไม่พบข้อมูล Device
                        </div>
                        <label
                          v-else
                          v-for="item in sourceList"
                          :key="item.hardware_uuid"
                          class="
                            flex
                            items-center
                            gap-3
                            px-3
                            py-2
                            cursor-pointer
                            hover:bg-gray-50
                            border-b border-gray-100
                            last:border-b-0
                          "
                        >
                          <input
                            type="radio"
                            name="source"
                            :value="item.hardware_uuid"
                            v-model="selectedSource"
                            class="text-cyan-600 focus:ring-cyan-500"
                          />
                          <div class="min-w-0">
                            <div
                              class="text-sm font-medium text-gray-900 truncate"
                            >
                              {{
                                item.title_th ||
                                item.title_en ||
                                item.hardware_serial_number
                              }}
                            </div>
                            <div class="text-xs text-gray-500">
                              <span>{{ item.hardware_code }}</span>
                              <span class="mx-1">·</span>
                              <span>{{ item.hardware_model.title }}</span>
                            </div>
                          </div>
                        </label>
                        <div
                          v-if="loadingMoreSource"
                          class="py-2 text-center text-xs text-gray-400"
                        >
                          โหลด...
                        </div>
                      </div>
                    </div>
                    <div class="flex items-center justify-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6 text-gray-500"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
                        />
                      </svg>
                    </div>
                    <div class="flex flex-col flex-1 min-h-0 gap-1">
                      <span class="text-sm font-medium text-gray-600"
                        >Device ปลายทาง</span
                      >
                      <div class="relative">
                        <input
                          v-model="searchTarget"
                          type="text"
                          placeholder="ค้นหา..."
                          class="
                            w-full
                            border border-gray-300
                            rounded-lg
                            pl-9
                            pr-8
                            py-2
                            text-sm
                            focus:ring-1
                            focus:ring-cyan-500
                            focus:border-cyan-500
                          "
                          @input="onSearchTarget"
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="
                            w-4
                            h-4
                            text-gray-400
                            absolute
                            left-2.5
                            top-1/2
                            transform
                            -translate-y-1/2
                            pointer-events-none
                          "
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.197 5.197a7.5 7.5 0 0 0 10.606 10.606Z"
                          />
                        </svg>
                        <button
                          v-if="searchTarget"
                          @click="clearSearchTarget"
                          type="button"
                          class="
                            absolute
                            right-2
                            top-1/2
                            transform
                            -translate-y-1/2
                            text-gray-400
                            hover:text-gray-600
                          "
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-4 h-4"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M6 18 18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                      <div
                        ref="targetList"
                        class="
                          border border-gray-300
                          rounded-lg
                          w-full
                          flex-1
                          overflow-y-auto
                          relative
                        "
                        @scroll="onScrollTarget"
                      >
                        <div
                          v-if="!filterCompany"
                          class="
                            flex
                            items-center
                            justify-center
                            h-full
                            text-sm text-gray-400
                            p-4
                          "
                        >
                          กรุณาเลือกบริษัทก่อน
                        </div>
                        <div
                          v-else-if="!selectedSource"
                          class="
                            flex
                            items-center
                            justify-center
                            h-full
                            text-sm text-gray-400
                            p-4
                            text-center
                          "
                        >
                          กรุณาเลือก Device ต้นทางก่อน
                        </div>
                        <div
                          v-else-if="
                            !loadingHardware && targetList.length === 0
                          "
                          class="
                            flex
                            items-center
                            justify-center
                            h-full
                            text-sm text-gray-400
                            p-4
                          "
                        >
                          ไม่พบข้อมูล Device
                        </div>
                        <label
                          v-else
                          v-for="item in targetList"
                          :key="item.hardware_uuid"
                          :class="[
                            'flex items-center gap-3 px-3 py-2 border-b border-gray-100 last:border-b-0',
                            item.hardware_uuid === selectedSource
                              ? 'opacity-40 cursor-not-allowed'
                              : 'cursor-pointer hover:bg-gray-50',
                          ]"
                        >
                          <input
                            type="radio"
                            name="target"
                            :value="item.hardware_uuid"
                            v-model="selectedTarget"
                            :disabled="item.hardware_uuid === selectedSource"
                            class="text-cyan-600 focus:ring-cyan-500"
                          />
                          <div class="min-w-0">
                            <div
                              class="text-sm font-medium text-gray-900 truncate"
                            >
                              {{
                                item.title_th ||
                                item.title_en ||
                                item.hardware_serial_number
                              }}
                            </div>
                            <div class="text-xs text-gray-500">
                              <span>{{ item.hardware_code }}</span>
                              <span class="mx-1">·</span>
                              <span>{{ item.hardware_model.title }}</span>
                            </div>
                          </div>
                        </label>
                        <div
                          v-if="loadingMoreTarget"
                          class="py-2 text-center text-xs text-gray-400"
                        >
                          โหลด...
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="
                bg-gray-50
                px-4
                py-3
                sm:px-6 sm:flex sm:flex-row-reverse
                mt-auto
              "
            >
              <button
                @click="onSubmit"
                type="button"
                class="
                  w-full
                  inline-flex
                  justify-center
                  rounded-md
                  border border-transparent
                  shadow-sm
                  px-4
                  py-2
                  bg-cyan-600
                  text-base
                  font-medium
                  text-white
                  hover:bg-cyan-700
                  focus:outline-none
                  focus:ring-2
                  focus:ring-offset-2
                  focus:ring-cyan-500
                  sm:ml-3 sm:w-auto
                "
              >
                ตกลง
              </button>
              <button
                @click="onCancel"
                type="button"
                class="
                  mt-3
                  w-full
                  inline-flex
                  justify-center
                  rounded-md
                  border border-gray-300
                  shadow-sm
                  px-4
                  py-2
                  bg-white
                  text-base
                  font-medium
                  text-gray-700
                  hover:bg-gray-50
                  focus:outline-none
                  focus:ring-2
                  focus:ring-offset-2
                  focus:ring-cyan-500
                  sm:mt-0 sm:ml-3 sm:w-auto
                "
              >
                ยกเลิก
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- success confirmation modal -->
    <transition
      enter-active-class="ease-out duration-200"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="ease-in duration-150"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="showSuccessModal"
        class="fixed z-60 inset-0 overflow-y-auto"
        aria-labelledby="success-modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div
          class="
            flex
            items-center
            justify-center
            min-h-screen
            pt-4
            px-4
            pb-20
            text-center
            sm:block sm:p-0
          "
        >
          <div
            class="fixed inset-0 bg-gray-500 bg-opacity-50 transition-opacity"
            aria-hidden="true"
          ></div>
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >
          <transition
            enter-active-class="ease-out duration-200"
            enter-class="opacity-0 translate-y-2 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-150"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-2 sm:scale-95"
          >
            <div
              v-if="showSuccessModal"
              class="
                inline-block
                align-middle
                bg-white
                rounded-xl
                text-left
                overflow-hidden
                shadow-xl
                transform
                transition-all
                sm:my-8 sm:max-w-sm sm:w-full
              "
            >
              <div
                class="px-6 pt-6 pb-4 flex flex-col items-center text-center"
              >
                <div
                  class="
                    flex
                    items-center
                    justify-center
                    w-14
                    h-14
                    rounded-full
                    bg-green-100
                    mb-4
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    class="w-7 h-7 text-green-600"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m4.5 12.75 6 6 9-13.5"
                    />
                  </svg>
                </div>
                <h3
                  id="success-modal-title"
                  class="text-lg font-semibold text-gray-900 mb-3"
                >
                  คัดลอกสำเร็จ
                </h3>
                <p class="text-sm text-gray-500 mb-1">คัดลอกการตั้งค่าจาก</p>
                <p class="text-sm font-medium text-gray-800 mb-1">
                  {{ successSourceName }}
                </p>
                <p class="text-sm text-gray-500 mb-1">ไปยัง</p>
                <p class="text-sm font-medium text-gray-800">
                  {{ successTargetName }}
                </p>
              </div>
              <div class="px-6 pb-5 flex justify-center">
                <button
                  @click="onCloseSuccessModal"
                  type="button"
                  class="
                    inline-flex
                    justify-center
                    rounded-md
                    border border-transparent
                    shadow-sm
                    px-8
                    py-2
                    bg-cyan-600
                    text-sm
                    font-medium
                    text-white
                    hover:bg-cyan-700
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-cyan-500
                  "
                >
                  ตกลง
                </button>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
    <!-- end success confirmation modal -->

    <!-- error modal -->
    <transition
      enter-active-class="ease-out duration-200"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="ease-in duration-150"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="showErrorModal"
        class="fixed z-60 inset-0 overflow-y-auto"
        aria-labelledby="error-modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div
          class="
            flex
            items-center
            justify-center
            min-h-screen
            pt-4
            px-4
            pb-20
            text-center
            sm:block sm:p-0
          "
        >
          <div
            class="fixed inset-0 bg-gray-500 bg-opacity-50 transition-opacity"
            aria-hidden="true"
          ></div>
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >
          <transition
            enter-active-class="ease-out duration-200"
            enter-class="opacity-0 translate-y-2 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-150"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-2 sm:scale-95"
          >
            <div
              v-if="showErrorModal"
              class="
                inline-block
                align-middle
                bg-white
                rounded-xl
                text-left
                overflow-hidden
                shadow-xl
                transform
                transition-all
                sm:my-8 sm:max-w-sm sm:w-full
              "
            >
              <div
                class="px-6 pt-6 pb-4 flex flex-col items-center text-center"
              >
                <div
                  class="
                    flex
                    items-center
                    justify-center
                    w-14
                    h-14
                    rounded-full
                    bg-red-100
                    mb-4
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    class="w-7 h-7 text-red-600"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 8v4m0 4v.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                </div>
                <h3
                  id="error-modal-title"
                  class="text-lg font-semibold text-gray-900 mb-3"
                >
                  เกิดข้อผิดพลาด
                </h3>
                <p class="text-sm text-gray-600">
                  {{ errorMessage }}
                </p>
              </div>
              <div class="px-6 pb-5 flex justify-center">
                <button
                  @click="onCloseErrorModal"
                  type="button"
                  class="
                    inline-flex
                    justify-center
                    rounded-md
                    border border-transparent
                    shadow-sm
                    px-8
                    py-2
                    bg-red-600
                    text-sm
                    font-medium
                    text-white
                    hover:bg-red-700
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-red-500
                  "
                >
                  ปิด
                </button>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
    <!-- end error modal -->
  </div>
</template>

<script>
import AppAutoComplete from '@/components/AppAutoComplete'
import _ from 'lodash'

export default {
  name: 'CopyDeviceModal',

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    AppAutoComplete,
  },

  data() {
    return {
      loadingSubmit: false,
      loadingCompany: false,
      loadingHardware: false,
      loadingMoreSource: false,
      loadingMoreTarget: false,
      showSuccessModal: false,
      successSourceName: '',
      successTargetName: '',
      showErrorModal: false,
      errorMessage: '',
      searchSource: '',
      searchTarget: '',
      selectedSource: null,
      selectedTarget: null,
      selectedSourceModelCode: null,
      filterCompany: null,
      sourceList: [],
      targetList: [],
      sourceTotalHardwares: 0,
      targetTotalHardwares: 0,
      sourceCurrentPage: 1,
      targetCurrentPage: 1,
      itemsPerPage: 10,
    }
  },

  watch: {
    isOpen(val) {
      if (val) {
        this.sourceList = []
        this.targetList = []
        this.sourceCurrentPage = 1
        this.targetCurrentPage = 1
        this.sourceTotalHardwares = 0
        this.targetTotalHardwares = 0
        this.filterCompany = null
        this.selectedSource = null
        this.selectedTarget = null
        this.selectedSourceModelCode = null
      }
    },

    selectedSource(val) {
      if (!val) {
        this.selectedSourceModelCode = null
        this.targetList = []
        this.targetCurrentPage = 1
        this.targetTotalHardwares = 0
        this.selectedTarget = null
        return
      }
      const item = this.sourceList.find((h) => h.hardware_uuid === val)
      const modelCode = item ? item.hardware_model.hardware_model_code : null
      if (modelCode !== this.selectedSourceModelCode) {
        this.selectedSourceModelCode = modelCode
        this.selectedTarget = null
        this.targetList = []
        this.targetCurrentPage = 1
        this.targetTotalHardwares = 0
        this.fetchTargetApi()
      }
    },
  },

  computed: {
    companies() {
      return this.$store.state.customer.customers.map((c) => ({
        ...c,
        text: c.company_code + ' - ' + c.title_th,
      }))
    },

    hasMoreSource() {
      return this.sourceList.length < this.sourceTotalHardwares
    },

    hasMoreTarget() {
      return this.targetList.length < this.targetTotalHardwares
    },
  },

  methods: {
    handleFilterCompany() {
      this.sourceList = []
      this.targetList = []
      this.sourceCurrentPage = 1
      this.targetCurrentPage = 1
      this.sourceTotalHardwares = 0
      this.targetTotalHardwares = 0
      this.selectedSource = null
      this.selectedTarget = null
      this.selectedSourceModelCode = null
      if (!this.filterCompany) return
      this.fetchSourceApi()
    },

    onSearchSource: _.debounce(function () {
      this.sourceList = []
      this.sourceCurrentPage = 1
      this.sourceTotalHardwares = 0
      this.fetchSourceApi()
    }, 500),

    clearSearchSource() {
      this.searchSource = ''
      this.sourceList = []
      this.sourceCurrentPage = 1
      this.sourceTotalHardwares = 0
      this.fetchSourceApi()
    },

    onSearchTarget: _.debounce(function () {
      this.targetList = []
      this.targetCurrentPage = 1
      this.targetTotalHardwares = 0
      this.fetchTargetApi()
    }, 500),

    clearSearchTarget() {
      this.searchTarget = ''
      this.targetList = []
      this.targetCurrentPage = 1
      this.targetTotalHardwares = 0
      this.fetchTargetApi()
    },

    onScrollSource(e) {
      const el = e.target
      const threshold = 50
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - threshold) {
        if (!this.loadingMoreSource && this.hasMoreSource) {
          this.sourceCurrentPage++
          this.fetchSourceApi(true)
        }
      }
    },

    onScrollTarget(e) {
      const el = e.target
      const threshold = 50
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - threshold) {
        if (!this.loadingMoreTarget && this.hasMoreTarget) {
          this.targetCurrentPage++
          this.fetchTargetApi(true)
        }
      }
    },

    async fetchSourceApi(append = false) {
      if (!this.filterCompany) return
      try {
        if (append) {
          this.loadingMoreSource = true
        } else {
          this.loadingHardware = true
        }

        const { hardwares, totalHardwares } = await this.$store.dispatch(
          'hardware/fetchHardwares',
          {
            params: {
              search: this.searchSource || undefined,
              company_uuid: this.filterCompany.company_uuid,
              sort: 'title_th:asc',
              is_manageable: true,
              limit: this.itemsPerPage,
              offset: (this.sourceCurrentPage - 1) * this.itemsPerPage,
            },
          }
        )

        this.sourceTotalHardwares = totalHardwares
        this.sourceList = append
          ? [...this.sourceList, ...hardwares]
          : [...hardwares]
      } catch (error) {
        this.errorMessage =
          error?.response?.data?.message ||
          'เกิดข้อผิดพลาดในการดึงข้อมูล Device ต้นทาง'
        this.showErrorModal = true
        if (process.env.NODE_ENV === 'development') {
          console.error('Error fetching source:', error)
        }
      } finally {
        this.loadingHardware = false
        this.loadingMoreSource = false
      }
    },

    async fetchTargetApi(append = false) {
      if (!this.filterCompany) return
      if (!this.selectedSourceModelCode) return
      try {
        if (append) {
          this.loadingMoreTarget = true
        } else {
          this.loadingHardware = true
        }

        const { hardwares, totalHardwares } = await this.$store.dispatch(
          'hardware/fetchHardwares',
          {
            params: {
              search: this.searchTarget || undefined,
              company_uuid: this.filterCompany.company_uuid,
              hardware_model_code: this.selectedSourceModelCode,
              sort: 'title_th:asc',
              is_manageable: true,
              limit: this.itemsPerPage,
              offset: (this.targetCurrentPage - 1) * this.itemsPerPage,
            },
          }
        )

        this.targetTotalHardwares = totalHardwares
        this.targetList = append
          ? [...this.targetList, ...hardwares]
          : [...hardwares]
      } catch (error) {
        this.errorMessage =
          error?.response?.data?.message ||
          'เกิดข้อผิดพลาดในการดึงข้อมูล Device ปลายทาง'
        this.showErrorModal = true
        if (process.env.NODE_ENV === 'development') {
          console.error('Error fetching target:', error)
        }
      } finally {
        this.loadingHardware = false
        this.loadingMoreTarget = false
      }
    },

    onCancel() {
      this.$emit('onClose')
    },

    async onSubmit() {
      try {
        this.loadingSubmit = true

        const sourceItem = this.sourceList.find(
          (h) => h.hardware_uuid === this.selectedSource
        )
        const targetItem = this.targetList.find(
          (h) => h.hardware_uuid === this.selectedTarget
        )

        await this.$store.dispatch('hardware/hardwareReplicate', {
          hardware_uuid: this.selectedSource,
          data: {
            destination_hardware_uuids: [this.selectedTarget],
            components: [
              'hardware_detail',
              'bell',
              'lock',
              'unlock',
              'hardware_group',
              'authority',
            ],
            mode: 'full',
          },
        })

        this.successSourceName =
          sourceItem?.title_th ||
          sourceItem?.title_en ||
          sourceItem?.hardware_serial_number ||
          '-'
        this.successTargetName =
          targetItem?.title_th ||
          targetItem?.title_en ||
          targetItem?.hardware_serial_number ||
          '-'
        this.showSuccessModal = true
      } catch (error) {
        this.errorMessage =
          error?.response?.data?.message ||
          'เกิดข้อผิดพลาดในการคัดลอกการตั้งค่า'
        this.showErrorModal = true
        if (process.env.NODE_ENV === 'development') {
          console.error('Error replicating hardware:', error)
        }
      } finally {
        this.loadingSubmit = false
      }
    },

    onCloseSuccessModal() {
      this.showSuccessModal = false
    },

    onCloseErrorModal() {
      this.showErrorModal = false
    },
  },
}
</script>
